import axios from 'axios';
// ---- external imports ----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports ----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { CAR_APIS } from '../endpoints';
// ---- local imports ----

class CarsService {
	async fetchAllCars() {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/${CAR_APIS.GET_ALL}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}
	
	async fetchLeasedCars(gameUserId) {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${CAR_APIS.LEASED_LIST}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}
	
	async leaseCar(gameUserId, id) {
		const data = { car: id };
		
		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${CAR_APIS.LEASE}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}

	async unleaseCar(gameUserId, id) {
		const data = { leasedCarId: id };
		
		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${CAR_APIS.UNLEASE}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}
}

export default new CarsService();
